import { Box } from '@cmpsr/components';
import { RefObject } from 'react';
import { ContentContainerV2 } from '../ContentContainer';
import MainCTA from '../main-cta/MainCTA';
import RiskAnalysisCard from '../risk-analysis-card/RiskAnalysisCard';

interface TopSectionProps {
  mainCTARef?: RefObject<HTMLButtonElement>;
  riskScore?: number;
  ctaLink: string;
}

const TopSection = ({ mainCTARef, riskScore, ctaLink }: TopSectionProps) => (
  <Box
    width="100%"
    background="gradient.dark"
    display="flex"
    flexDirection="column"
    alignItems="center"
    gap="spacer-4"
    py="spacer-6"
  >
    <ContentContainerV2>
      <Box display="flex" flexDirection="column" gap="spacer-8" alignItems="center">
        <RiskAnalysisCard riskScore={riskScore} />
        <MainCTA ref={mainCTARef} ctaLink={ctaLink} />
      </Box>
    </ContentContainerV2>
  </Box>
);

export default TopSection;
